<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <div
      id="changevehicle"
      class="modal fade"
      :class="{ show: show }"
      style="background: rgba(0,0,0,0.5)"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" v-click-outside="onCancel" id="modal">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h4 class="mb-0">{{ $t("change-vehicle") }}</h4>
              <p class="cursor-pointer px-2" @click="onCancel">
                <img src="../../assets/images/Vector (1).png" alt="" />
              </p>
            </div>
            <div
              v-if="mssg"
              align="center"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              align="center"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>
            <form class="p-2" @submit.prevent="editvehicle">
              <div class="form-group">
                <label for="vehicle">{{ $t("vehicle-name") }}</label>
                <select
                  v-model="selectedVehicle"
                  name="vehicle"
                  class="form-control"
                  id="vehicle"
                >
                  <option
                    value="none"
                    :disabled="selectedVehicle === 'none'"
                  >
                    {{ $t("none") }}
                  </option>
                  <option
                    v-for="vehicle in vehicles"
                    :key="vehicle.id"
                    :value="vehicle.id"
                    :disabled="vehicle.id === selectedVehicle"
                  >
                    {{ vehicle.name }}
                  </option>
                </select>
              </div>

              <div type="submit" class="btn-add">
                <button>{{ $t("change") }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalContainer from "../../components/ModalContainer";
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";

export default {
  name: "ChangeVehicle",
  components: {
    ModalContainer,
    Loading,
  },
  mounted() {
    this.initialiseForm();
  },
  watch: {
    vehicle: {
      handler() {
        this.initialiseForm();
      },
      deep: true,
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    show: Boolean,
    vehicle: Array,
    driverid: String,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      selectedVehicle: "none",
      showSuccessPopup: false,
      mssg: "",
      Errormssg: "",
    };
  },
  computed: {
    ...mapGetters(["vehicles"]),
  },
  methods: {
    ...mapActions([
      "getDriverDetails",
      "editDriverDetailsVehicle",
      "unassignDriverDetailsVehicle",
    ]),
    onCancel() {
      this.$emit("closeChangeVehicleModal");
    },
    initialiseForm() {
      if (this.vehicle && this.vehicle.length > 0) {
        this.selectedVehicle = this.vehicle[0].id || "none";
      } else {
        this.selectedVehicle = "none";
      }
    },
    editvehicle() {
      this.isLoading = true;

      if (this.selectedVehicle === "none") {
        this.unassignDriverDetailsVehicle({
          unassignedVehicle: {
            vehicle: this.vehicle[0].id,
          },
          driverId: this.driverid,
        })
          .then((res) => {
            this.getDriverDetails(this.driverid);
            this.onCancel();
            this.$emit("showSuccessPopup", {
              msg: this.$t("unassign_vehicle_mssg"),
              heading: this.$t("unassign_vehicle_heading"),
            });
            this.isLoading = false;
            this.mssg =
              res.data.message[0].toUpperCase() + res.data.message.slice(1);
          })
          .catch((error) => {
            this.isLoading = false;
            this.Errormssg =
              error.response.data.message[0].toUpperCase() +
              error.response.data.message.slice(1);
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      } else {
        this.editDriverDetailsVehicle({
          newDriverDetailsVehicle: {
            vehicle: this.selectedVehicle,
          },
          driverId: this.driverid,
        })
          .then((res) => {
            this.getDriverDetails(this.driverid);
            this.onCancel();
            this.$emit("showSuccessPopup", {
              msg: this.$t("change_vehicle_mssg"),
              heading: this.$t("change_vehicle_heading"),
            });
            this.isLoading = false;
            this.mssg =
              res.data.message[0].toUpperCase() + res.data.message.slice(1);
          })
          .catch((error) => {
            this.isLoading = false;
            this.Errormssg =
              error.response.data.message[0].toUpperCase() +
              error.response.data.message.slice(1);
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      }
    },
  },
};
</script>


<style scoped>
label,
.form-control::placeholder {
  font-weight: 400;
  color: rgba(94, 106, 121, 1);
}

label {
  list-style: 15.6px;
  font-size: 12px;
}

.form-control::placeholder {
  font-size: 14px;
  line-height: 19.69px;
}

.btn-add {
  padding: 0;
  border-radius: 0;
  width: 100%;
  display: flex;
  justify-content: right;
}

.btn-add > button {
  border: none;
  border-radius: 16px;
  background-color: rgba(33, 62, 122, 1);
  color: rgba(247, 248, 249, 1);
  width: 84px;
  height: 44px;
  padding: 12px, 30px, 12px, 30px;
  font-size: 14px;
  font-weight: 600;
}

@media (min-width: 768px) {
  .modal-dialog {
    max-width: 500px !important;
  }
}
</style>
